import { render } from "./EditorPlayer.vue?vue&type=template&id=b30af746&scoped=true"
import script from "./EditorPlayer.vue?vue&type=script&lang=js"
export * from "./EditorPlayer.vue?vue&type=script&lang=js"

import "./EditorPlayer.vue?vue&type=style&index=0&id=b30af746&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b30af746"]])

export default __exports__